import { ReactElement, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { downloadFile, downloadLearnerValidationFile } from 'store/fileDownload/actions';
import { MatchTemplate } from 'store/fileDownload/types';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from 'store';
import { PARSAction } from 'core/models';

interface IManualDownloadLinkProps {
  children: ReactNode;
  fileName?: string;
  id: string;
  map: MatchTemplate;
  to: string;
}

export const ManualDownloadLink = (props: IManualDownloadLinkProps): ReactElement => {
  const { fileName, to, id, map, children } = props;
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();

  const handleDownload = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    if (id === 'lvtbatch') {
      dispatch(downloadLearnerValidationFile({ controller: to, matchTemplate: map }));
    } else {
      dispatch(downloadFile({ controller: to, id, matchTemplate: map }));
    }
  };

  return (
    <a href={to} download={fileName || map[id]} onClick={handleDownload} role="link">
      {children}
    </a>
  );
};
